var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_281_436",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "matrix(-4.37114e-08 1 1 4.37114e-08 0 0)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_281_436)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.1125 15.8875C21.6027 15.3973 21.6027 14.6027 21.1125 14.1125L13.4142 6.41421C12.6332 5.63316 11.3668 5.63317 10.5858 6.41421L2.8875 14.1125C2.39735 14.6027 2.39735 15.3973 2.8875 15.8875C3.37765 16.3777 4.17235 16.3777 4.6625 15.8875L12 8.55L19.3375 15.8875C19.8277 16.3777 20.6223 16.3777 21.1125 15.8875Z",
    fill: "#092064"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow_up.00eefca5d5b19605471b665dd2a6f632.svg";
export { ForwardRef as ReactComponent };